import { useEffect, useState } from "react";
import useDebouncedCallback from "@shared/utils/hooks/useDebouncedCallback";
import useThrottledCallback from "@shared/utils/hooks/useThrottledCallback";

export const useDebouncedValue = (
  value: any,
  onChange: (value: any) => void,
  throttle?: boolean,
  wait?: number
) => {
  const [localValue, setLocalValue] = useState<any>(value);
  const [lastLoadedValue, setLastLoadedValue] = useState<any>(value);

  useEffect(() => {
    setLocalValue(value);
    setLastLoadedValue(value);
  }, [value]);

  const debouncedOnChange = useDebouncedCallback({ callback: onChange, wait });
  const throttledOnChange = useThrottledCallback({ callback: onChange, wait });
  const _onChange = (updatedValue: any) => {
    setLocalValue(updatedValue);
    (throttle ? throttledOnChange : debouncedOnChange)(updatedValue);
  };

  // This is done to make sure the returned value is always synced with the passed in one since the local value is
  // only synced with the passed in value after one render cycle
  const currentValue = lastLoadedValue !== value ? value : localValue;

  return [currentValue, _onChange];
};
